import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=d3c3fc76&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3c3fc76')) {
      api.createRecord('d3c3fc76', component.options)
    } else {
      api.reload('d3c3fc76', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=d3c3fc76&", function () {
      api.rerender('d3c3fc76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-203ngpnSk8sy9/JS/videoIframe.vue"
export default component.exports